import config from '@/config';
import { fetchData } from '@/model/utils/fetch';

export const fetchJackpotBetFeedsByLiquidity = async ({
  currency,
}: {
  currency?: string;
}) => {
  try {
    const response = await fetchData<{
      [key: string]: any;
    }>({
      url: `${config.urls.bffBaseUrl}/jackpots/v2/jpbet/feeds-by-liquidity`,
      queryParameters: {
        currency,
      },
    });

    return response;
  } catch (err) {
    console.error(
      `There was a problem while fetching Jackpots Bet feeds by liquidity data. ${config.urls.bffBaseUrl}/jackpots/v2/jpbet/feeds-by-liquidity`
    );
    console.error(err);
    return {};
  }
};
